import { render } from "./WhoWeAre.vue?vue&type=template&id=f943a3bc&scoped=true"
const script = {}

import "./WhoWeAre.vue?vue&type=style&index=0&id=f943a3bc&scoped=true&lang=scss"

import exportComponent from "/Users/iti/Documents/icandy_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f943a3bc"]])

export default __exports__